import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageSelectionPopupComponent } from '../image-selection-popup/image-selection-popup.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DataManipService } from '../../Services/data-manip.service';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { ConfigSettingService } from '../../Services/config-setting.service';
import { CommonService } from '../../Services/common.service';
import { EncrptDecreptService } from '../../Services/encrpt-decrept.service';
import { async } from '@angular/core/testing';
import { HelperService } from '../../Services/helper.service';
const beep = '../../../assets/sound/beep.mp3';
const beep2 = '../../../assets/sound/beep-04.mp3';

@Component({
  selector: 'app-image-selection-question',
  templateUrl: './image-selection-question.component.html',
  styleUrls: ['./image-selection-question.component.scss']
})
export class ImageSelectionQuestionComponent implements OnInit {
  // check svn working or not
  // 2
  title = 'scrollDownApp';

   
  @ViewChild('successModal', { static: false }) public successModal: ModalDirective;
  @ViewChild('instructionModal', { static: false }) public instructionModal: ModalDirective;
  @ViewChild('correctImagModel', { static: false }) public correctImagModel: ModalDirective;

  

  firstLevelSelection: boolean = true;
  secondLevelSelection: boolean = false;
  thirdLevelSelection: boolean = false;
  fourthLevelSelection: boolean = false;
  fifthLevelSelection: boolean = false;
  sixthLevelSelection: boolean = false;
  visibleTest: boolean = true;
  levelName: string = ""
  headerMessage: string = ""
  testRound: number = 0;
  blinkScreenTime;
  blinkScreenTimeInMinutes;
  blinkScreenSeconds;
  selectedFourImageList: any[] = [];
  selectedOneImage: any = {};
  shuffledArrayList = [];
  clickedId;
  popupMessage: string = '';
  count: number = 1;
  dynamic: number = 1;
  imageListForSuccessTest: any[] = []
  selectedLanguageForTest: string = '';
  isNextBtnDisabled: boolean = true;
  randomSelectedObject: any = {};
  selectedFourImageId = []
  selectedFinalImage = []

  resultObject: any = ''
  matchedImageCount = 0;
  firstTimeRecogFinalSymAtFrequency: string = '';
  isShowCountDownClock: boolean = false;

  // Blink-secreen properties
  strobeRunning = false;
  warningAccepted = false;
  mainTimer;

  timerInterval = 1;
  currentColorIndex = 0;
  colorsTransition = 1;
  totalRounds = 8;

  sliderValue = 28; // Frequency controller

  frequencyName = {};

  DeltaFrequency = 0;
  ThetaFrequency = 0;
  AlphaFrequency = 0;
  BetaFrequency = 0;

  constantFrequencyHeartz = 0;
  DeltaFrequencyHeartz = 0;
  ThetaFrequencyHeartz = 0;
  AlphaFrequencyHeartz = 0;
  BetaFrequencyHeartz = 0;

  baseUrl: string = '';

  colors = ["", "", "", "", "", "", "", ""];
  backgroundElement: any;
  backgroundCircleElement: any;

  duringTestInstr: string = "";
  duringTestPopupInstr: string = "";
  description: string = "";
  instructionHeading: string = '';
  instructionsList: string = '';

  osc1;
  osc2;
  context1;
  context2;
  audio;

  showCountDown;
  countDownSeconds: number = 0; //forgot timer

  showCountTimer;
  countDownTimer: number = 0; //forgot timer
  isRoundChanged: boolean = false;
  isScrollDown = false;
  correctImgIndntificationText:string='';

  private oscillateObj: any = {
    constant: undefined,
    variant: undefined,
  };
  constructor(private encryptService: EncrptDecreptService, private configSetting: ConfigSettingService, private router: Router, private commonServices: CommonService, private NgbModal: NgbModal, private activatedRoute: ActivatedRoute, public dataManipSrvc: DataManipService, private helper:HelperService) { }

  ngOnInit(): void {

    setTimeout(() => {
      this.dataManipSrvc.headerName = "";
    }, 80);
    this.colors = ["ED2939", "383838", "ED2939", "383838", "ED2939", "383838", ""];

    this.setQueryParams();
    this.headerMessage = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepone']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepone']['headingm'] : this.duringTestInstr['stepone']['headingh'];
    this.description = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepone']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepone']['descriptionm'] : this.duringTestInstr['stepone']['descriptionh'];
    this.baseUrl = this.configSetting.getBaseUrl();
  }

  ngAfterViewInit(): void {
    this.backgroundCircleElement = document.getElementById('strobe_div');
    this.backgroundElement = document.getElementById('strobe_div-overlay');

    document.addEventListener("scroll", (event) => {
        this.isScrollDown = this.helper.scrollHeightCondition();
    });
  }

  setQueryParams() {
    this.activatedRoute.queryParams.subscribe(params => {

      let data = JSON.parse(params['data']);
      this.imageListForSuccessTest = data['testpattern'];

      this.selectedLanguageForTest = data['userselectedtestlanguadge'];
      this.duringTestInstr = this.dataManipSrvc.testInstructions['duringtestinstr'];
      this.duringTestPopupInstr = this.dataManipSrvc.testInstructions['duringtestpopupinstr'];

      this.frequencyName = this.dataManipSrvc.requireddata['frequency'];

      this.DeltaFrequency = this.dataManipSrvc.requireddata['frequencyValue']['DeltaFrequency'];
      this.ThetaFrequency = this.dataManipSrvc.requireddata['frequencyValue']['ThetaFrequency'];
      this.AlphaFrequency = this.dataManipSrvc.requireddata['frequencyValue']['AlphaFrequency'];
      this.BetaFrequency = this.dataManipSrvc.requireddata['frequencyValue']['BetaFrequency'];

      this.constantFrequencyHeartz = this.dataManipSrvc.requireddata['constantFrequencyHeartz'];
      this.DeltaFrequencyHeartz = this.dataManipSrvc.requireddata['frequencyHeartz']['DeltaHeartz'];
      this.ThetaFrequencyHeartz = this.dataManipSrvc.requireddata['frequencyHeartz']['ThetaHeartz'];
      this.AlphaFrequencyHeartz = this.dataManipSrvc.requireddata['frequencyHeartz']['AlphaHeartz'];
      this.BetaFrequencyHeartz = this.dataManipSrvc.requireddata['frequencyHeartz']['BetaHeartz'];
    });
  }

  showBackground() {
    this.backgroundElement.style.display = 'block';
    this.countDownTimer = this.dataManipSrvc.requireddata['blinkscreentime'];
    let timerInterval = setInterval(() => {

      if (!this.countDownTimer || this.countDownTimer == 1) {
        this.countDownTimer = 0;
        this.showCountTimer = '';
        clearInterval(timerInterval);
        this.stopStrobe();
        return;
      }
      this.countDown(this.countDownTimer - 1, 'timer');
    }, 1000)
  }

  countDown(time, type) {
    let min = Math.floor(time / 60).toString();
    let sec = Math.floor(time % 60).toString();

    min = min.length == 1 ? ("0" + min) : min;
    sec = sec.length == 1 ? (type == 'timer' ? "0" + sec : sec) : sec;

    if (type == 'timer') {
      this.showCountTimer = `${min + ':' + sec}`;
      if (min == '00' && sec == '00') {
        return;
      }
      this.countDownTimer--;
    } else {
      this.showCountDown = sec;
      // console.log("sec", sec);

      if (sec == '0') {
        this.isShowCountDownClock = false;
        return;
      }
      this.countDownSeconds--;
    }
  }
  blinkScreenAndOscillate = (frequency, constantFrequencyHeartz, variantFrequencyHeartz) => {
    let isPlay: boolean = true;
    this.startOscillation(constantFrequencyHeartz, 'constant');
    this.startOscillation(variantFrequencyHeartz, 'variant');
    // const interval = setInterval(() => {
    //   if (this.isRoundChanged) {
    //     clearInterval(interval);
    //     this.stopOscillation();
    //     isPlay = false;
    //   }
    //   if (isPlay) {
    //     // this.audio.play();
    //     this.backgroundCircleElement.style.background = "#ED2939";
    //   } else {
    //     // this.audio.pause();
    //     // this.audio.currentTime = 0;
    //     this.backgroundCircleElement.style.background = "#383838";
    //   }
    //   isPlay = !isPlay
    // }, frequency)
    // console.log("blinkScreenAndOscillate frequency ", { frequency, constantFrequencyHeartz, variantFrequencyHeartz });
  }

  instructionOkBtn() {
    this.isRoundChanged = false;
    let freq = 0;
    const miliseconds = 1000;
    this.isShowCountDownClock = true;
    this.countDownSeconds = +this.dataManipSrvc.requireddata['countdownseconds'];
    // 6 = 446 - 440
    // 10 = 450 - 440
    // 16 = 456 - 440

    this.audio = new Audio(beep);
    let variantFrequencyHeartz = 0;
    let frequencyValue = 0;
    if (this.testRound == 0) {
      // freq = +(miliseconds / (this.DeltaFrequencyHeartz - this.constantFrequencyHeartz));
      variantFrequencyHeartz = this.DeltaFrequencyHeartz;
      frequencyValue = this.DeltaFrequency;
    } else if (this.testRound == 1) {
      // freq = +(miliseconds / (this.ThetaFrequencyHeartz - this.constantFrequencyHeartz));
      variantFrequencyHeartz = this.ThetaFrequencyHeartz;
      frequencyValue = this.ThetaFrequency;
    } else if (this.testRound == 2) {
      this.audio = new Audio(beep2);
      // freq = +(miliseconds / (this.AlphaFrequencyHeartz - this.constantFrequencyHeartz));
      variantFrequencyHeartz = this.AlphaFrequencyHeartz;
      frequencyValue = this.AlphaFrequency;
    } else if (this.testRound == 3) {
      this.audio = new Audio(beep2);
      // freq = +((miliseconds) / (this.BetaFrequencyHeartz - this.constantFrequencyHeartz));
      variantFrequencyHeartz = this.BetaFrequencyHeartz;
      frequencyValue = this.BetaFrequency;
    }
    // console.log(frequencyValue);

    let countDownInterval = setInterval(() => {

      if (this.countDownSeconds == 0) {
        this.showBackground();
        this.startBlink(frequencyValue)
        this.startOscillation(this.constantFrequencyHeartz, 'constant');
        this.startOscillation(variantFrequencyHeartz, 'variant');
        // this.playBeepSoundAndBlinkScreen(true, (freq / 2));
        // this.blinkScreenAndOscillate(frequencyValue, this.constantFrequencyHeartz, variantFrequencyHeartz);
        this.countDownSeconds = 0;
        this.showCountDown = '';

        clearInterval(countDownInterval);
        return;
      } else {
        this.countDown(this.countDownSeconds, 'countdown')
      }
    }, 1000)

    this.testRound++;
  }

  audioHandler1(HZ) {
    this.context1 = new AudioContext();
    this.osc1 = this.context1.createOscillator();
    let cgain = this.context1.createGain();
    let panner = new StereoPannerNode(this.context1);

    this.osc1.type = "sine";

    this.osc1.frequency.value = HZ;
    cgain.gain.value = 0.9;
    panner.pan.value = -1 + 100 / 100;

    this.osc1.connect(cgain);
    cgain.connect(panner);
    panner.connect(this.context1.destination);
    this.osc1.start();

  }

  audioHandler2(HZ) {
    this.context2 = new AudioContext();
    this.osc2 = this.context2.createOscillator();
    let cgain = this.context2.createGain();
    let panner = new StereoPannerNode(this.context2);

    this.osc2.type = "sine";

    this.osc2.frequency.value = HZ;
    cgain.gain.value = 0.9;
    panner.pan.value = -1 + 100 / 100;

    this.osc2.connect(cgain);
    cgain.connect(panner);
    panner.connect(this.context2.destination);
    this.osc2.start();

  }

  nextSelectedImages() {
    if (this.firstLevelSelection) {
      this.headerMessage = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['steptwo']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['steptwo']['headingm'] : this.duringTestInstr['steptwo']['headingh'];
      this.description = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['steptwo']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['steptwo']['descriptionm'] : this.duringTestInstr['steptwo']['descriptionh'];
      this.firstLevelSelection = false;
      this.thirdLevelSelection = true;
      this.isNextBtnDisabled = true;
      this.dynamic++;
    }
    else if (this.thirdLevelSelection) {
      this.headerMessage = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepthree']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepthree']['headingm'] : this.duringTestInstr['stepthree']['headingh'];
      this.description = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepthree']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepthree']['descriptionm'] : this.duringTestInstr['stepthree']['descriptionh'];
      this.isNextBtnDisabled = false;
      this.thirdLevelSelection = false
      this.fourthLevelSelection = true;
      this.dynamic++;

    } else if (this.fourthLevelSelection) {
      this.instructionHeading = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepfour']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepfour']['headingm'] : this.duringTestInstr['stepfour']['headingh'];
      this.instructionsList = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepfour']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepfour']['descriptionm'] : this.duringTestInstr['stepfour']['descriptionh'];
      this.instructionModal.config = {keyboard:false, backdrop: 'static'};
      this.instructionModal.show();
      this.headerMessage = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepfourcon']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepfourcon']['headingm'] : this.duringTestInstr['stepfourcon']['headingh'];
      this.description = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepfourcon']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepfourcon']['descriptionm'] : this.duringTestInstr['stepfourcon']['descriptionh'];
      this.thirdLevelSelection = false;
      this.fourthLevelSelection = false;
      this.fifthLevelSelection = true;
      this.shuffledArrayList = this.selectedFourImageList.sort((a, b) => 0.5 - Math.random());
      this.dynamic++;
    } else if (this.fifthLevelSelection) {
      this.headerMessage = '';
      this.description = '';
      this.sixthLevelSelection = true;
      this.fifthLevelSelection = false;
    }
  }



  goPrivious() {
    this.resetTestFormat(false)
    this.isNextBtnDisabled = false;
    this.selectedOneImage['finalselected'] = false;
    this.selectedOneImage = {};
    // this.selectedFinalImage = [];
  }

  resetTestFormat(flag = true) {
    if (flag) {
      this.dynamic = 0;
    } else {
      this.dynamic--;
    }
    this.headerMessage = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepone']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepone']['headingm'] : this.duringTestInstr['stepone']['headingh'];
    this.description = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepone']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepone']['descriptionm'] : this.duringTestInstr['stepone']['descriptionh'];
    this.firstLevelSelection = true;
    this.secondLevelSelection = false;
    this.thirdLevelSelection = false;
    this.fourthLevelSelection = false;
    this.fifthLevelSelection = false;
    this.sixthLevelSelection = false;
  }

  finishTest() {
    let params =
    {
      "userid": this.encryptService.encrypt(this.dataManipSrvc.userId + ""),
      "usertestid": this.encryptService.encrypt(this.dataManipSrvc.usertestid + ""),
      "testid": this.encryptService.encrypt(this.dataManipSrvc.testId + "")
    };
    let apiUrl = this.configSetting.getBaseUrl() + "dashtest/downloadResultPDF";
    this.commonServices.downloadReport(apiUrl, params).subscribe(successResp => {

      var blob = new Blob([successResp], { type: 'application/pdf' });
      var url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");

      this.resetTestFormat();
      this.router.navigate(["/dashboard"], { queryParams: { testid: this.dataManipSrvc.testId, usertestid: this.dataManipSrvc.usertestid } });
    },
      err => {
        alert("Problem while downloading the file.");

        console.error(err);
      }
    );
  }
  chooseRandomImageClick: boolean = false;
  chooseRandomImageCorrectOrWrong: boolean = false;
  chooseRandomImage(value, index) {
    
    if (this.chooseRandomImageClick) {
      return;
    }
    this.clickedId = index;
    setTimeout(() => {
      this.shuffledArrayList = this.selectedFourImageList.sort((a, b) => 0.5 - Math.random());
      this.showPopUpForCorrectIncorrectImg();
      // this.showInstructionOnClick();
      this.clickedId = -1
      this.chooseRandomImageClick = false;
    }, 2000);

    this.randomSelectedObject[this.count] = { imgid: value['imgid'], baseimgname: value['baseimgname'], imgnamee: value['imgnamee'], imgnamem: value['imgnamem'], imgnameh: value['imgnameh'], frequency: { freqNo: this.count, freqNme: this.frequencyName[`freqNamee${this.count}`], freqNmm: this.frequencyName[`freqNamem${this.count}`], freqNmh: this.frequencyName[`freqNameh${this.count}`] } };

    if (this.randomSelectedObject[this.count]['imgid'] == this.selectedOneImage['imgid']) {
      this.matchedImageCount++;
      this.chooseRandomImageCorrectOrWrong = true;
      if (this.matchedImageCount == 1) {
        this.firstTimeRecogFinalSymAtFrequency = this.randomSelectedObject[this.count]['frequency']
      }
    }else{
      this.chooseRandomImageCorrectOrWrong = false;

    }
    this.chooseRandomImageClick = true;
    this.count++;
  }

  showPopUpForCorrectIncorrectImg(){
    if (this.chooseRandomImageCorrectOrWrong) {
      this.correctImgIndntificationText= this.correctPopUpText(this.dynamic);

    }else{
      this.correctImgIndntificationText= this.incorrectPopUpText(this.dynamic);
    }
    console.log(this.dynamic);
    this.correctImagModel.config = {keyboard:false, backdrop: 'static'};
    this.correctImagModel.show();
  }

  private correctPopUpText(round:number){
    let text = '';
    if(round == 7){
      if(this.selectedLanguageForTest=='e'){
        text = 'The symbol you identified is correct.'
      }else if(this.selectedLanguageForTest=='m'){
        text = 'तुम्ही ओळखलेले प्रतीक बरोबर आहे.'
      }else{
        text = 'आपने पहचाना हुआ प्रतीक सही है।'
      }
    }else{
      text = this.msgToDisplayForRightIdentifyImage();
    }
    return text;
  }

  private incorrectPopUpText(round:number){
    let text = '';
    if(round == 7){
      if(this.selectedLanguageForTest=='e'){
        text = 'The symbol you identified is incorrect.'
      }else if(this.selectedLanguageForTest=='m'){
        text = 'तुम्ही ओळखलेले प्रतीक चुकीचे आहे.'
      }else{
        text = 'आपने पहचाना हुआ प्रतीक गलत है।'
      }
    }else{
      text = this.msgToDisplayForWrongIdentifyImage();
    }
    return text;
  }

  private msgToDisplayForRightIdentifyImage(){
    let textMsg = '';
    if(this.selectedLanguageForTest=='e'){
      textMsg = 'The symbol you identified is correct.'
    }else if(this.selectedLanguageForTest=='m'){
      textMsg = 'तुम्ही ओळखलेले प्रतीक बरोबर आहे.'
    }else{
      textMsg = 'आपने पहचाना हुआ प्रतीक सही है।'
    }
    return textMsg;
  }

  private msgToDisplayForWrongIdentifyImage(){
    let textMsg = '';
    if(this.selectedLanguageForTest=='e'){
      textMsg = 'The symbol you identified is incorrect. Better luck next time! '
    }else if(this.selectedLanguageForTest=='m'){
      textMsg = 'तुम्ही ओळखलेले प्रतीक चुकीचे आहे. पुढील फेरीसाठी शुभेच्छा!'
    }else{
      textMsg = 'आपने पहचाना हुआ प्रतीक गलत है। अगले दौर के लिए शुभकामनाएँ!'
    }
    return textMsg;
  }

  showInstructionOnClick() {
    if (this.testRound == 1) {
      this.instructionHeading = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepfive']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepfive']['headingm'] : this.duringTestInstr['stepfive']['headingh'];
      this.instructionsList = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepfive']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepfive']['descriptionm'] : this.duringTestInstr['stepfive']['descriptionh'];
      this.instructionModal.config = {keyboard:false, backdrop: 'static'};
      this.instructionModal.show();
      this.dynamic++;
      this.headerMessage = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepfivecon']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepfivecon']['headingm'] : this.duringTestInstr['stepfivecon']['headingh'];
      this.description = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepfivecon']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepfivecon']['descriptionm'] : this.duringTestInstr['stepfivecon']['descriptionh'];
    } else if (this.testRound == 2) {
      this.instructionHeading = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepsix']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepsix']['headingm'] : this.duringTestInstr['stepsix']['headingh'];
      this.instructionsList = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepsix']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepsix']['descriptionm'] : this.duringTestInstr['stepsix']['descriptionh'];
      this.instructionModal.config = {keyboard:false, backdrop: 'static'};
      this.instructionModal.show();
      this.dynamic++;
      this.headerMessage = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepsixcon']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepsixcon']['headingm'] : this.duringTestInstr['stepsixcon']['headingh'];
      this.description = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepsixcon']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepsixcon']['descriptionm'] : this.duringTestInstr['stepsixcon']['descriptionh'];
    } else if (this.testRound == 3) {
      this.instructionHeading = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepseven']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepseven']['headingm'] : this.duringTestInstr['stepseven']['headingh'];
      this.instructionsList = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepseven']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepseven']['descriptionm'] : this.duringTestInstr['stepseven']['descriptionh'];
      this.instructionModal.config = {keyboard:false, backdrop: 'static'};
      this.instructionModal.show();
      this.dynamic++;
      this.headerMessage = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepsevencon']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepsevencon']['headingm'] : this.duringTestInstr['stepsevencon']['headingh'];
      this.description = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['stepsevencon']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['stepsevencon']['descriptionm'] : this.duringTestInstr['stepsevencon']['descriptionh'];
    } else if (this.testRound == 4) {
      this.headerMessage = '';
      this.description = '';
      this.sixthLevelSelection = true;
      this.fifthLevelSelection = false;
      this.instructionHeading = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['finalmessage']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['finalmessage']['headingm'] : this.duringTestInstr['finalmessage']['headingh'];
      this.instructionsList = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['finalmessage']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['finalmessage']['descriptionm'] : this.duringTestInstr['finalmessage']['descriptionh'];
      this.instructionModal.config = {keyboard:false, backdrop: 'static'};
      this.instructionModal.show();
      this.finishSuccessTest()
    }

  }

  clickFirstFourImages(event, item, i) {
    if (item['selected']) {
      item['selected'] = !item['selected'];
      let filterArray = []
      filterArray = this.selectedFourImageList.filter(ele => {
        return ele['imgid'] !== item['imgid'];
      })
      this.selectedFourImageList = filterArray;
      if (this.selectedFourImageList.length !== 4) this.isNextBtnDisabled = true;
      return;
    };
    if (this.selectedFourImageList.length == 4) {
      this.popupMessage = this.selectedLanguageForTest == 'e' ? this.duringTestPopupInstr['popupinstre'] : this.selectedLanguageForTest == 'm' ? this.duringTestPopupInstr['popupinstrm'] : this.duringTestPopupInstr['popupinstrh'];
      this.successModal.config = {keyboard:false, backdrop: 'static'};
      this.successModal.show();
      return;
    }
    if (!item['selected']) item['selected'] = true;

    this.selectedFourImageList.push(item);
    if (this.selectedFourImageList.length == 4) this.isNextBtnDisabled = false;
  }

  selectOneImage(item, i) {
    if (item['imgid'] == this.selectedOneImage['imgid']) {
      this.selectedOneImage = {};
      item['finalselected'] = false;
      // this.selectedFinalImage = [];
      this.isNextBtnDisabled = true;
      return;
    }
    // if (this.selectedFinalImage.length == 1) {
    //   this.popupMessage = 'Only one images to be selected.'
    //   this.successModal.show();
    //   return;
    // }
    // this.selectedFinalImage.push(item)
    this.selectedOneImage['finalselected'] = false;
    item['finalselected'] = true;

    this.selectedOneImage = item;
    this.isNextBtnDisabled = false;
    
  }

  finishSuccessTest() {
    this.selectedFourImageList.forEach(item => {
      if (item['selected']) delete item['selected'];
      if (item['finalselected']) delete item['finalselected'];
    })
    delete this.selectedOneImage['selected'];
    delete this.selectedOneImage['finalselected'];

    if (this.matchedImageCount == 0) {
      this.firstTimeRecogFinalSymAtFrequency = this.randomSelectedObject[1]['frequency'];
    }

    let param = {
      testid: this.dataManipSrvc.testId,
      usertestid: this.dataManipSrvc.usertestid,
      selectedLanguage: this.selectedLanguageForTest,
      userTestPaper: {
        firstlevel: this.selectedFourImageList,
        secondlevel: this.selectedOneImage,
        thirdlevel: this.randomSelectedObject,
        noOfTimeRecognizedImg: this.matchedImageCount,
        firstTimeRecogFinalSymAtFrequency: this.firstTimeRecogFinalSymAtFrequency
      }
    }

    let apiUrl = this.configSetting.getBaseUrl() + "dashtest/finishsuccesstest";
    this.commonServices.postMethod(apiUrl, param).subscribe(successResp => {
      if (successResp['errorCode'] == "000000") {
        this.resultObject = JSON.stringify(successResp['Data'])
      }
      else {
        this.popupMessage = `Something went wrong. ${successResp['errorDescription']}`;
        this.successModal.config = {keyboard:false, backdrop: 'static'};
        this.successModal.show();
      }
    }, (err) => {
      console.log(err);
    })
  }

  // Blink-screen functions

  startBlink(val) {
    this.visibleTest = false;
    this.backgroundElement = document.getElementById('strobe_div-overlay');
    this.backgroundElement.style.display = 'block';

    this.backgroundCircleElement = document.getElementById('strobe_div');

    this.setSliderValue(val)
  }

  startStrobe(interval) {
    this.timerInterval = (interval == null) ? this.timerInterval : interval;

    this.strobeRunning = true;
    this.mainTimerFunction();
  }

  mainTimerFunction = () => {
    // re-set timer
    if (this.strobeRunning == true) {
      clearTimeout(this.mainTimer);
      this.mainTimer = setTimeout(this.mainTimerFunction, this.timerInterval);
    }

    // get next used color
    this.currentColorIndex = this.getNextColor();

    if ((this.colorsTransition == 0) || (this.sliderValue >= 93)) {
      this.backgroundCircleElement.style.background = "#" + this.colors[this.currentColorIndex]
    } else {
      this.backgroundCircleElement.style.background = "#" + this.colors[this.currentColorIndex]
    }


    this.currentColorIndex++;
  }

  getNextColor() {
    var next_color = this.currentColorIndex;

    while (this.colors[next_color] == "") {
      next_color++;
      if (next_color > 6) {
        next_color = 0;
      }
    }
    if (next_color > 6) {
      next_color = 0;
    }

    return next_color;
  }

  setSliderValue(val, update_slider: boolean = true, set_unsaved: boolean = true) {

    var update_slider = (update_slider == null) ? true : update_slider;
    var set_unsaved = (set_unsaved == null) ? true : set_unsaved;

    // check boundaries
    if (val < 1) {
      val = 1;
    }
    if (val > 123) {
      val = 123;
    }

    // update
    this.sliderValue = +(val);
    this.strobeRunning = true;

    if (this.sliderValue <= 5) {
      this.timerInterval = +((6 - this.sliderValue) * (1000 * 60));
    } else if (this.sliderValue <= 15) {
      // every 50, 40, 30, 25, 20, 15, 10 secs
      var display_value = 60 - ((this.sliderValue - 5) * 5);
      this.timerInterval = (display_value * 1000);
    } else if (this.sliderValue <= 24) {
      this.timerInterval = +((25 - this.sliderValue) * 1000);
    } else if (this.sliderValue >= 53) {
      // 30, 35, 40, 45, 50, 55, 60 per sec
      var display_value = 30 + ((this.sliderValue - 53) * 5);
      this.timerInterval = +(1000 / display_value);
    } else {
      this.timerInterval = +(1000 / (this.sliderValue - 23));
    }

    // restart timer
    if (this.strobeRunning == true) {
      this.startStrobe(null);
    }
  }

  stopStrobe() {
    this.strobeRunning = false;
    clearTimeout(this.mainTimer);
    this.visibleTest = true;
    this.backgroundElement.style.display = 'none';
    this.stopOscillation();
    this.isRoundChanged = true;
    this.isShowCountDownClock = false;
  }

  private oscillatOn(freq, frerType: 'variant' | 'constant') {
    // const contextClass = (window.AudioContext ||
    //   window?.webkitAudioContext ||
    //   window.mozAudioContext ||
    //   window.oAudioContext ||
    //   window.msAudioContext);
    const contextClass = (window.AudioContext);
    const context: any = new contextClass();
    let gainValue = 0.9;
    let gainNode = context.createGain ? context.createGain() : context.createGainNode();
    let oscillator;

    let oscs = { sine: 0, square: 1, sawtooth: 2, triangle: 3 };


    oscillator = context.createOscillator();

    oscillator.type = 0;
    oscillator.frequency.value = freq;

    oscillator.connect(gainNode);
    gainNode.connect(context.destination);
    gainNode.gain.value = gainValue;

    if (oscillator.type === parseInt(oscillator.type)) {
      oscillator.type = 0;
    } else {
      oscillator.type = "sine";
    }
    oscillator.start ? oscillator.start(0) : oscillator.noteOn(0)
    // oscillator.start(0);
    this.oscillateObj[frerType] = oscillator
  }
  private stopOscillation() {
    this.oscillateObj['constant']?.stop();
    this.oscillateObj['variant']?.stop();

    this.oscillateObj['constant']?.disconnect();
    this.oscillateObj['variant']?.disconnect();
  }

  private startOscillation(freq, frerType: 'variant' | 'constant', val = 0.1) {
    if (typeof this.oscillateObj[frerType]?.oscillator != 'undefined') this.oscillateObj[frerType]?.oscillator.disconnect();
    this.oscillatOn(freq, frerType);
    this.oscillateObj[frerType].gainValue = val;
  }

  scrollDown() {
    this.isScrollDown = this.helper.scrollHeightCondition();

    window.scrollBy({
      top: this.isScrollDown ? -window.scrollY : 300,
      behavior: 'smooth'
    });
  }
}
